import React from 'react';
import LoginLayout from '../login/LoginLayout';
import { useMsgText } from '../../localization/hooks';
import { Str } from '../../localization/translationKeys';


type Props = {
  className?: string;
};


const SsoErrorPage: React.FC<Props> = props => {
  const header = useMsgText(Str.SsoFailure);


  return (
    <LoginLayout
      isLoading={false}
      className={props.className}
      headerMsg={header}
    >
    </LoginLayout>
  );
};

export default SsoErrorPage;
